import { render } from "./Done.vue?vue&type=template&id=d97b8274"
import script from "./Done.vue?vue&type=script&lang=js"
export * from "./Done.vue?vue&type=script&lang=js"

import exportComponent from "/var/www/extranet-sinistre/production/client/node_modules/@vue/cli-service/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__